/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  isDraw?: boolean,
  isHighScore?: boolean,
  isHomeTeam?: boolean,
  isNumberScore?: boolean,
  score?: string,
  team: string
};

const defaultProps = {
  isDraw: false,
  isHighScore: false,
  isHomeTeam: false,
  isNumberScore: false,
  score: undefined
};

const Wrapper = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  textTransform: 'uppercase'
});

const Prefix = styled.span({
  width: 12
});

const TeamName = styled.div({
  alignItems: 'flex-start',
  display: 'flex',
  flexBasis: 'auto',
  flexGrow: 0,
  flexShrink: 0,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});

const HomeIcon = styled.span(({ theme }) => ({
  color: theme.color.basis5,
  fontSize: theme.fontSize.xxsmall,
  paddingLeft: 4,
  paddingRight: 4
}));

const TeamScore = styled.div({
  flexBasis: 'auto',
  flexGrow: 0,
  flexShrink: 1,
  paddingLeft: '0.5em',
  textAlign: 'right'
});

function MatchScoreLine({ isDraw, isHighScore, isHomeTeam, isNumberScore, score, team }: Props) {
  return (
    <Wrapper>
      <TeamName>
        {!isDraw && isNumberScore && (
          <Prefix>{isHighScore && <span className="ion-arrow-right-b" />}</Prefix>
        )}
        {team}
        {isHomeTeam && <HomeIcon className="ion-home" />}
      </TeamName>
      {score !== undefined && <TeamScore>{score}</TeamScore>}
    </Wrapper>
  );
}

MatchScoreLine.defaultProps = defaultProps;

export default MatchScoreLine;
